import { eventGroup, eventGroupStatus } from 'common/middleware/api';
import { injectError } from './error';
import { ApiError } from 'common/modules/api';
import StringUtils from 'common/utils/StringUtils';
import TeamUtils from 'common/utils/TeamUtils';
import EventNotificationService from 'common/services/EventNotificationService';
import { FetchTypeEnum } from 'common/enums/FetchEnum';

export default class EventGroupActions {
    static FETCH_EVENTGROUP_SUCCESS = 'FETCH_EVENTGROUP_SUCCESS';
    static FETCH_EVENTGROUPS_SUCCESS = 'FETCH_EVENTGROUPS_SUCCESS';
    static FETCH_EVENTGROUPS_START = 'FETCH_EVENTGROUPS_START';
    static FETCH_EVENTGROUPS_ERROR = 'FETCH_EVENTGROUPS_ERROR';
    static RESOLVE_EVENTGROUP_START = 'RESOLVE_EVENTGROUP_START';
    static RESOLVE_EVENTGROUP_SUCCESS = 'RESOLVE_EVENTGROUP_SUCCESS';
    static RESOLVE_EVENTGROUP_ERROR = 'RESOLVE_EVENTGROUP_ERROR';
    static FETCH_EVENTCOUNT_START = 'FETCH_EVENTCOUNT_START';
    static FETCH_EVENTCOUNT_SUCCESS = 'FETCH_EVENTCOUNT_SUCCESS';

    static pollEventGroup = (...params) => {
        return dispatch => {
            return new Promise((resolve, reject) => {
                dispatch(
                    EventGroupActions.fetchEventGroup(...params, {
                        onSuccess: resolve,
                        onFailure: reject
                    })
                );
            });
        };
    };

    static pollFetchEventGroup = (
        clientId,
        dateString,
        shiftId,
        teamIds,
        userId,
        poller
    ) => {
        return () => {
            const params = {
                clientId,
                shift: shiftId,
                date: dateString
            };

            if (teamIds && teamIds.length > 0) {
                params.carrierTeam = teamIds.join(',');
                params.carrierClient = clientId;
            }

            if (userId) {
                params.userId = userId;
                params.carrierClient = clientId;
            }

            poller.setPollerState({
                apiModel: eventGroup,
                params,
                autoTerminateOn4xx: true
            });
        };
    };

    static fetchEventGroup = (
        clientId,
        dateString,
        shiftId,
        teamIds,
        userId,
        location,
        fetchType,
        { onSuccess, onFailure } = {}
    ) => {
        return (dispatch, getState) => {
            var params = {
                clientId,
                shift: shiftId,
                date: dateString
            };

            if (TeamUtils.hasNoTeam(teamIds)) {
                return;
            }

            if (teamIds && teamIds.length > 0) {
                params.carrierTeam = teamIds.join(',');
                params.carrierClient = clientId;
            }

            if (userId) {
                params.userId = userId;
                params.carrierClient = clientId;
            }
            if (fetchType === FetchTypeEnum.Initial) {
                dispatch(EventGroupActions.setEventGroupIsLoading(params));
            }
            return eventGroup
                .fetch(params)
                .then(eventGroups => {
                    onSuccess?.(eventGroups);
                    if (
                        EventNotificationService &&
                        StringUtils.isEmpty(userId)
                    ) {
                        EventNotificationService.process(
                            eventGroups,
                            getState,
                            params,
                            location
                        );
                    }
                    dispatch(
                        EventGroupActions.injectEventGroups(
                            eventGroups,
                            params,
                            location
                        )
                    );
                    return;
                })
                .catch(error => {
                    onFailure?.(error);
                    dispatch(EventGroupActions.setFetchError(error, params));
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                        return;
                    }
                    throw error;
                });
        };
    };

    static injectEventGroups = (eventGroups, params, location) => {
        return {
            type: EventGroupActions.FETCH_EVENTGROUPS_SUCCESS,
            response: eventGroups,
            params,
            location
        };
    };

    static injectEventGroup = (eventGroup, params) => {
        return {
            type: EventGroupActions.FETCH_EVENTGROUP_SUCCESS,
            response: eventGroup,
            params
        };
    };

    static setEventResolveStart = (params, eventIds, multiple) => {
        return {
            type: EventGroupActions.RESOLVE_EVENTGROUP_START,
            params,
            eventIds,
            multiple
        };
    };

    static setEventResolveSuccess = (params, eventIds, multiple) => {
        return {
            type: EventGroupActions.RESOLVE_EVENTGROUP_SUCCESS,
            params,
            eventIds,
            multiple
        };
    };

    static setEventResolveError = (params, eventIds, multiple) => {
        return {
            type: EventGroupActions.RESOLVE_EVENTGROUP_ERROR,
            params,
            eventIds,
            multiple
        };
    };

    static setEventGroupIsLoading = params => {
        return {
            type: EventGroupActions.FETCH_EVENTGROUPS_START,
            params
        };
    };

    static setFetchError = (error, params) => {
        return {
            type: EventGroupActions.FETCH_EVENTGROUPS_ERROR,
            response: error,
            params
        };
    };

    static resolveEventGroup = (
        clientId,
        dateString,
        shiftId,
        definitionId,
        eventIds,
        teamIds,
        userId,
        multiple
    ) => {
        return dispatch => {
            var params = {
                clientId,
                shift: shiftId,
                date: dateString,
                definitionId
            };

            if (teamIds && teamIds.length > 0) {
                params.carrierTeam = teamIds.join(',');
                params.carrierClient = clientId;
            }

            if (userId) {
                params.userId = userId;
                params.carrierClient = clientId;
            }
            dispatch(
                EventGroupActions.setEventResolveStart(
                    params,
                    eventIds,
                    multiple
                )
            );
            eventGroupStatus
                .post(params, {
                    eventIds,
                    status: 'OK'
                })
                .then(eventGroup => {
                    dispatch(
                        EventGroupActions.setEventResolveSuccess(
                            params,
                            eventIds,
                            multiple
                        )
                    );
                    dispatch(
                        EventGroupActions.injectEventGroup(eventGroup, params)
                    );
                })
                .catch(error => {
                    dispatch(
                        EventGroupActions.setEventResolveError(
                            params,
                            eventIds,
                            multiple
                        )
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    };
}

export { EventGroupActions };
